import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private readonly MIN_DESKTOP_SCREEN_WIDTH: number = 1221;
  private readonly isMobileSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isMobileView());
  isMobile$: Observable<boolean> = this.isMobileSubject.asObservable();

  constructor() {
    window.addEventListener('resize', this.onResize.bind(this));
  }

  private onResize() {
    this.isMobileSubject.next(this.isMobileView());
  }

  private isMobileView(): boolean {
    return window.innerWidth < this.MIN_DESKTOP_SCREEN_WIDTH;
  }
}
